import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderCancellationSingleRequestImplEncoder } from "../../encoder/OrderCancellationSingleRequestImplEncoder";

import * as CubiqTS from "../../index";
import { OrderCancellationSingleRequest } from "../OrderCancellationSingleRequest";

export class OrderCancellationSingleRequestImpl
  extends ConcreteEncodable
  implements OrderCancellationSingleRequest
{
  public static enType: string = "com.bcdfx.model.event.OrderCancellationSingleRequestImpl";

  /*FID=1*/
  public orderIds: Array<string> | null = null;
  /*FID=2*/
  public reason: string;
  /*FID=4*/
  public tradingChannel: string;
  /*FID=5*/
  public clientReference: string;
  /*FID=6*/
  public dealtCurrency: string;
  /*FID=7*/
  public orderQty: CubiqTS.BigNumber | null = null;
  /*FID=8*/
  public orderType: CubiqTS.OrderType;
  /*FID=9*/
  public productType: CubiqTS.Product;
  /*FID=10*/
  public symbol: string;
  /*FID=11*/
  public isBuy: boolean;
  /*FID=12*/
  public accountCode: string;
  /*FID=13*/
  public requestRate: CubiqTS.BigNumber | null = null;
  /*FID=14*/
  public strategyParameters: Array<CubiqTS.StrategyParameter> | null = null;
  /*FID=15*/
  public userCd: string;
  /*FID=16*/
  public oboUser: string;
  /*FID=17*/
  public ptpComposites: Array<CubiqTS.OrderPTPComposite> | null = null;
  /*FID=18*/
  public traderGroup: string;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderCancellationSingleRequestImplEncoder.Instance;
    this.setEncodableType(OrderCancellationSingleRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "OrderCancellationSingleRequestImpl[" +
      "orderIds=" +
      this.orderIds +
      "reason=" +
      this.reason +
      "tradingChannel=" +
      this.tradingChannel +
      "clientReference=" +
      this.clientReference +
      "dealtCurrency=" +
      this.dealtCurrency +
      "orderQty=" +
      this.orderQty +
      "orderType=" +
      this.orderType +
      "productType=" +
      this.productType +
      "symbol=" +
      this.symbol +
      "isBuy=" +
      this.isBuy +
      "accountCode=" +
      this.accountCode +
      "requestRate=" +
      this.requestRate +
      "strategyParameters=" +
      this.strategyParameters +
      "userCd=" +
      this.userCd +
      "oboUser=" +
      this.oboUser +
      "ptpComposites=" +
      this.ptpComposites +
      "traderGroup=" +
      this.traderGroup +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
